import type { JSX } from "react";
import { useTranslation } from "react-i18next";

import { statusIntent } from "@/design";
import { Badge } from "@/shared/ui/badge";

type StockStatusCode = "healthy" | "low_stock" | "out_of_stock" | "oversold";

interface StockStatusBadgeProps {
  status: StockStatusCode;
  className?: string;
}

const STATUS_I18N_KEY: Record<StockStatusCode, string> = {
  healthy: "status.healthy",
  low_stock: "status.low_stock",
  out_of_stock: "status.out_of_stock",
  oversold: "status.oversold",
};

export function StockStatusBadge({ status, className }: StockStatusBadgeProps): JSX.Element {
  const { t } = useTranslation("inventory");
  return (
    <Badge
      intent={statusIntent("stock", status)}
      dot
      className={className}
      data-testid="stock-status-badge"
      data-status={status}
    >
      {t(STATUS_I18N_KEY[status])}
    </Badge>
  );
}
